import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fedb188c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "inner1" }
const _hoisted_7 = { class: "title_left" }
const _hoisted_8 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_9 = { style: {"width":"70%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"65%"} })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "エージェントコード", -1))
const _hoisted_13 = { class: "form-control" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, "※", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "会社名", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, "※", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "部署名", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, "※", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "担当者名", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, "※", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "メールアドレス", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "備考１", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "備考２", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "required-mark" }, "※", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "機能権限", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = {
  class: "form-inline flex-container",
  style: {"width":"70%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                (_ctx.isUpdateMode)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("ユーザー編集")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("ユーザー登録")
                    ], 64))
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("td", null, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.agName), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_14,
                  _hoisted_15,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "kaisyaName",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agUserData.kaisyaName) = $event)),
                      type: "text",
                      placeholder: "会社名",
                      maxlength: "255",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.agUserData.kaisyaName]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_16,
                  _hoisted_17,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "busyoName",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agUserData.busyoName) = $event)),
                      type: "text",
                      placeholder: "部署名",
                      maxlength: "255",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.agUserData.busyoName]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _hoisted_19,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "tantousyaName",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agUserData.tantousyaName) = $event)),
                      type: "text",
                      placeholder: "担当者名",
                      maxlength: "255",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.agUserData.tantousyaName]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _hoisted_21,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "email",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.agUserData.email) = $event)),
                      type: "text",
                      placeholder: "メールアドレス",
                      maxlength: "255",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.agUserData.email]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_22,
                  _hoisted_23,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "bikou1",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agUserData.bikou1) = $event)),
                      type: "text",
                      placeholder: "備考１",
                      maxlength: "255",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.agUserData.bikou1]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_24,
                  _hoisted_25,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      id: "bikou2",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.agUserData.bikou2) = $event)),
                      type: "text",
                      placeholder: "備考２",
                      maxlength: "255",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.agUserData.bikou2]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _hoisted_27,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      id: "roleId",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.agUserData.roleId) = $event)),
                      class: "form-control"
                    }, [
                      _hoisted_28,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinouKengenList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_29))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.agUserData.roleId]
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                type: "button",
                name: "btnBack",
                class: "btn btn-footer btn-primary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
              }, " 戻る "),
              _createElementVNode("button", {
                type: "button",
                name: "btnClear",
                class: "btn btn-footer btn-primary",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
              }, " クリア "),
              _createElementVNode("button", {
                type: "button",
                name: "btnFixed",
                class: "btn btn-footer btn-primary",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFixed && _ctx.onFixed(...args)))
              }, " 確定 ")
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ])
  ], 64))
}